import { defineStore } from 'pinia';
import { ref } from 'vue';
import RequestsUtils from '@/helpers/RequestsUtils';
import { AxiosResponse } from 'axios';
import { ENV } from '@/constants';

export const usePlanetStore = defineStore('planet', () => {
  // Data
  const isUpdateInProcess = ref(false);
  const version = ref('v1.0.0');
  const systemOutOfDate = ref(false);
  const _planetStatusProcessTracker = ref(null);

  // Methods
  function loadUpdateInProcessStatus() {
    return RequestsUtils.sendRequest({
      methodName: 'GET',
      url: 'tools/status',
    }).then((response: AxiosResponse) => {
      isUpdateInProcess.value = response?.data?.readonly || false;
    });
  }

  function loadPlanetVersion() {
    return RequestsUtils.sendRequest({
      methodName: 'GET',
      url: 'tools/versions',
    }).then((response: AxiosResponse) => {
      const planetVersion = response?.data?.planet;
      if (planetVersion && planetVersion !== version.value && !isUpdateInProcess.value) {
        systemOutOfDate.value = true;
        planetStatusProcessTrackerStop();
      }
    });
  }

  function setVersionFromEnvVar() {
    version.value = ENV.VITE_PLANET_VERSION;
  }

  function planetStatusProcessTrackerStart() {
    if (ENV.DEV) {
      isUpdateInProcess.value = ENV.VITE_PLANET_UPDATE_IN_PROCESS === 'true';
    } else {
      _planetStatusProcessTracker.value = setInterval(() => {
        loadUpdateInProcessStatus();
        loadPlanetVersion();
      }, 5000);
      loadUpdateInProcessStatus();
      loadPlanetVersion();
    }
  }

  function planetStatusProcessTrackerStop() {
    clearInterval(_planetStatusProcessTracker.value);
  }

  return {
    isUpdateInProcess,
    version,
    systemOutOfDate,
    planetStatusProcessTrackerStart,
    setVersionFromEnvVar,
  };
});
